import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaStethoscope, FaBandAid, FaHeartbeat, FaProcedures, FaHospital, FaFlask, FaPills, FaEye, FaAmbulance } from 'react-icons/fa';
import './OtherServices.css';

const OtherServices = () => {
  const services = [
   
    {
      icon: <FaBandAid />,
      title: 'Wound Care',
      link: '/other-services#wound-care'
    },
    {
      icon: <FaProcedures />,
      title: 'Post-Operative Care',
      link: '/other-services#post-operative-care'
    },
    {
      icon: <FaHospital />,
      title: 'Post Hospitalization',
      link: '/other-services#post-hospitalization'
    }, {
      icon: <FaStethoscope />,
      title: 'Rehabilitation Services',
      link: '/other-services#physiotherapy'
    },
    {
      icon: <FaAmbulance />,
      title: 'Ambulance and Emergency Service',
      link: '/other-services#ambulance-emergency-service'
    },
    {
      icon: <FaPills />,
      title: 'Pain Management',
      link: '/other-services#pain-management'
    },
    {
      icon: <FaHeartbeat />,
      title: 'Chronic Disease',
      link: '/other-services#chronic-disease'
    },
    {
      icon: <FaEye />,
      title: 'Home Eye Care',
      link: '/other-services#eye-care'
    }
  ];

  return (
    <section className="other-services-section">
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title">Other Services</h2>
          <p className="section-subtitle">Supporting Your Loved Ones With Compassionate Care</p>
        </div>
        
        <Row className="g-4">
          {services.map((service, index) => (
            <Col key={index} lg={3} md={4} sm={6}>
              <Card className="service-card h-100">
                <Card.Body className="text-center">
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <Card.Title>{service.title}</Card.Title>
                  <div className="btn-wrap">
                    <Button as={Link} to={service.link} variant="link" className="read-more-btn" aria-label={`Read more about ${service.title}`}>
                      Read More
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default OtherServices;
